import SEO from '../../components/base/SEO';
import SchemaOrg from '../../components/base/SchemaOrg';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import StorySection from './components/StorySection';
import WhatWeDoSection from './components/WhatWeDoSection';
import PhilosophySection from './components/PhilosophySection';
import ImpactSection from './components/ImpactSection';
import BrandSection from './components/BrandSection';
import TechnologySection from './components/TechnologySection';
import CommunitySection from './components/CommunitySection';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Daygreen',
    alternateName: '데이그린',
    url: siteUrl,
    logo: `${siteUrl}/vite.svg`,
    description: '봉제 기술 교육과 업사이클링을 통해 지속가능한 패션 산업을 만들어가는 사회적기업',
    foundingDate: '2016',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Seoul',
      addressCountry: 'KR',
    },
    sameAs: [],
    areaServed: 'KR',
    knowsAbout: ['지속가능한 패션', '업사이클링', '봉제 기술 교육', '사회적기업', '친환경 패션'],
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Daygreen',
    url: siteUrl,
    description: '지속가능한 패션, 기술 자립 공동체',
    inLanguage: 'ko-KR',
  };

  return (
    <>
      <SEO
        title="Daygreen - 지속가능한 패션, 기술 자립 공동체 | 인증 사회적기업"
        description="Daygreen은 봉제 기술 교육과 업사이클링을 통해 지속가능한 패션 산업을 만들어가는 사회적기업입니다. re:day 브랜드와 기능성 워크웨어로 환경과 공동체를 생각합니다."
        keywords="사회적기업, 지속가능한 패션, 업사이클링, 봉제 기술 교육, re:day, 워크웨어, 친환경 패션, 기술 자립, 공동체"
        canonical="/"
        ogType="website"
      />
      <SchemaOrg schema={[organizationSchema, websiteSchema]} />
      <div className="min-h-screen">
        <Navbar />
        <HeroSection />
        <StorySection />
        <WhatWeDoSection />
        <PhilosophySection />
        <ImpactSection />
        <BrandSection />
        <TechnologySection />
        <CommunitySection />
        <Footer />
      </div>
    </>
  );
}